<template>
	<main id="form">
		<form autocomplete="off" v-on:submit.self.stop.prevent="validateForm()">
			<h2>{{this.properties && getLabel(this.properties.title)}}</h2>
			<ul v-if="properties.fields">
				<li>
					<pools_radio_input v-on:validateField="validateExtraInput" v-bind:params="getParams('contractType')" v-bind:oldValue="oldValue['contractType']" v-bind:lang="lang"></pools_radio_input>
				</li>
				<li>
					<date_input v-on:validateField="validateField" v-bind:params="getParams('start_date')" v-bind:oldValue="oldValue['start_date']" v-bind:lang="lang"></date_input>
					<br>
					<span>Le démarrage des alternants pour l'AUDIT se fait exclusivement en octobre et février</span>
				</li>
				<!-- 3 == Beginer -->
				<li v-if="this.display.contractType === '0' || this.display.contractType == '1' || this.display.contractType == '2' || this.display.contractType == '3'">
					<number_input v-on:validateField="validateField" v-bind:params="getParams('duration_month')" v-bind:oldValue="oldValue['duration_month']" v-bind:lang="lang"></number_input>
				</li>
				<!-- 1 == Alternance -->
				<li v-if="display.contractType == 2">
					<text_input v-on:validateField="validateField" v-bind:params="getParams('rythme')" v-bind:oldValue="oldValue['rythme']" v-bind:lang="lang"></text_input>
				</li>
				<!--
				<li v-if="display.contractType == 5">
					<text_input v-on:validateField="validateField" v v-bind:params="getParams('otherContract')" v-bind:oldValue="oldValue['otherContract']" v-bind:lang="lang"></text_input>
				</li> 5 == Other -->
				<li>
					<pools_checkbox_input v-on:validateField="validateField" v-bind:params="getParams('mobility_specify')" v-bind:oldValue="oldValue['mobility_specify']" v-bind:lang="lang"></pools_checkbox_input>
				</li>
			</ul>
			<button v-bind:class="isActive ? 'selected' : ''" type="submit">{{getLabel(fields.next)}}</button>
		</form>
	</main>
</template>

<script>
//Input components
import text_input from '@/components/candidate_forms/text_input.vue';
import radio_input from '@/components/candidate_forms/radio_input.vue';
import pools_radio_input from '@/components/candidate_forms/pools_radio_input.vue';
import pools_checkbox_input from '@/components/candidate_forms/pools_checkbox_input.vue';
import number_input from '@/components/candidate_forms/number_input.vue';
import month_input from '@/components/candidate_forms/month_input.vue';
import date_input from '@/components/candidate_forms/date_input.vue';
import lib from '@/libs/main.js';
import componentTools from '@/libs/componentTools.js';

function checkForm(scope){
	if(!scope.properties || !scope	|| !Array.isArray(scope.properties.fields)) return false;
	if(([0, 1, 2, 3].findIndex(e => e == scope.display.contractType) != -1) && !scope.answer['duration_month']) return false;
	if(scope.display.contractType == 2 && !scope.answer['rythme']) return false; // 4 == Alternating
	if(!scope.answer['mobility_specify']) return false;
	return ['contractType', 'start_date','mobility_specify'].every(e => scope.answer[e]);
}

function remove_duration(val){
	if([4].find(v => v == val)) delete this.answer['duration_month'];
	if(val != 1) delete this.answer['rythme'];
}
function remove_mobility(val){
	if(!val.length) delete this.answer['mobility_specify'];
}

export default {
	name: 'availabilityTpl',
	data() {
		return {
			answer : {},
			oldValue : {},
			display : {
				contractType: false,
				mobility : false,
				duration_month: false,
			},
			isActive : false,
			fields : {
				next : {
					fr : 'Valider',
					en : 'Next'
				}
			},
		}
	},
	props : ['currentSession', 'properties', 'lang', 'templateIndex'],
	components : {
		text_input, radio_input, pools_radio_input, number_input, pools_checkbox_input, month_input, date_input
	},
	methods : {
		validateForm : function() {
			if(!checkForm(this)) return;
			remove_mobility.call(this, this.answer['mobility_specify']);
			let out = {};
			this.properties.fields.forEach( field => {
				if(this.answer[field.params.name]) out[field.params.name] = this.answer[field.params.name];
			});
			this.$emit('validateStep', this.$options.name, out);
		},
		validateField : function(name, value) {
			this.answer[name] = value;
			this.isActive = checkForm(this);
		},
		validateExtraInput : function(name, value) {
			const params = this.getParams(name);
			const answer = params && params.options && params.options.find(e => e.value == value);
			if(typeof this.display[name] != "undefined") this.display[name] = value;
			this.answer[name] = value;
			this.isActive = checkForm(this);
		},
		getParams : function(name){
			return this.properties.fields.find(x => x.params && x.params.name == name).params;
		},
		getLabel : componentTools.getLabel
	},
	watch : {
		currentSession : {
			handler : function(val){
				let candidateTplRes = val.stepsResults && val.stepsResults[this.$options.name + '_' + this.templateIndex];
				if(!candidateTplRes){
					Object.keys(this.answer).forEach(k => this.$set(this.oldValue, k, null)); //cf vue reactivity for binded object properties
					this.answer = {};
				}
			},
			deep : true,
		},
		"display.contractType" : remove_duration,
		"display.mobility" : remove_mobility
	},
	created : function(){
		componentTools.created.call(this);
		const oldRes = this.currentSession.stepsResults[this.$options.name + '_' + this.templateIndex];
		if(oldRes) this.oldValue = oldRes;
	},
	mounted : componentTools.mounted
};
</script>

<style lang="less">
@import '../../assets/less/conf.import.less';
#form ul{
	li{
		position: relative;
		margin-top: 3%;
		margin-bottom: 3%;
		label{
			position: absolute;
			left: 0;
			margin-top: 2%;
			max-width: 40%;
			text-align: left;
		}
		input{
			&[type="date"]{
				width: 40%;
				margin-left: 60%;
			}
			&[type="checkbox"], &[type="radio"]{
				display: inline-block;
			}
			&[type="text"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="email"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="number"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="tel"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="month"]{
				width: 35%;
				margin-left: 65%;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ey/availability.vue